module.exports = __webpack_public_path__ + "img/q15.7c3ca9bf.png";